/**
 * Toggles a boolean value, switching to the opposite of the passed parameter.
 */
export var toggle = function toggle(oldValue) {
  return !oldValue;
};